import { Inbox, CreditCard, Search, Clipboard, RotateCcw, Landmark, File, X,SquareCheckBig, Ban, Box } from 'lucide-react';

export const API_CONFIG = {
  BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
  BASE_API: `${process.env.REACT_APP_BACKEND_URL}`,
  WHATSAPP_NUMBER: "525585353729",
};

/**
 * Rutas de la aplicación
 */
export const ROUTES = {
  HOME: "/",
  LOGIN: "/login",
  REGISTER: "/register",
  CATEGORIES: "/categorias",
  CATEGORY_DETAIL: "/categoria/:categoryId",
  DASHBOARD: "/dashboard",
  SOPORTE: "/support",
};

/**
 * Mensajes de error comunes
 */
export const ERROR_MESSAGES = {
  LOGIN_FAILED: "Error de login. Verifica tus credenciales.",
  REGISTER_FAILED: "Error de registro. Intenta nuevamente.",
  NETWORK_ERROR: "Error de conexión. Verifica tu internet.",
  LOADING_ERROR: "Error al cargar la información.",
};

/**
 * Configuración de animaciones y UI
 */
export const UI_CONFIG = {
  ANIMATION_DURATION: 300,
  LOADING_TIMEOUT: 10000,
  SCREENSHOT_QUALITY: 20,
};

export const estadosDisponibles = [
  { id: "todas", name: "Todas las Solicitudes" },
  { id: "cotizacion_solicitada", name: "Cotización Solicitada", color: "blue" , icon: <Clipboard />},
  { id: "cotizacion_enviada", name: "Cotización Enviada", color: "indigo", icon: <Inbox />},
  { id: "pago_procesado", name: "Pago Procesado", color: "green", icon: <CreditCard />},
  { id: "esperando_documentos", name: "Esperando Documentos", color: "yellow", icon: <File />},
  { id: "documentos_en_revision", name: "Tramite en Revisión", color: "blue", icon: <Search />},
  { id: "documentos_rechazados", name: "Documentos Rechazados", color: "red", icon: <X />},
  { id: "en_proceso", name: "Pago", color: "purple", icon: <RotateCcw />},
  { id: "esperando_autoridad", name: "Esperando Autoridad", color: "orange", icon: <Landmark />},
  { id: "listo_para_entrega", name: "Listo para Entrega", color: "emerald", icon: <Box />},
  {
    id: "completado",
    name: "Completado",
    color: "green",
    icon: <SquareCheckBig />
  },
  {
    id: "cancelado",
    name: "Cancelado",
    color: "red",
    icon: <Ban />
  }
];
